define('views/modules/help/contact/contact-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/i18n',
    // views
    'views/parts/menu/menu-action',
    'views/modules/help/contact/contact-form',
    'views/modules/help/tutorial/tutorial-content',
    // templates
    'text!templates/modules/help/contact/contact-content.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    i18n,
    // views
    VMenuAction,
    VContactForm,
    VTutorialContent,
    // templates
    TContactContent
) {

    var VContactContent = Backbone.View.extend({
        template: TContactContent,

        regions: {
            root: ".contact-content",
            menu: '.menu-actions',
            form: '.contact-form',
            tutorial: '.tutorial-content'
        },

        initialize: function(opt) {
            opt = opt || {};

            _.extend(this, {
                profile: opt.profile,
                group: opt.group,
                url: opt.url
            });

            var view = this.view = {
                // menu: new VMenuAction({
                //     context: this,
                //     onClick: this.onActionClick,
                //     radio: false,
                //     collection: new Backbone.Collection([
                //         { title: i18n.t('messages:tooltip-send-message'), content: 'Send', itemClass: 'pull-right', icon: 'fa fa-paper-plane', callback: this.onSendAction }
                //     ]),
                //     tooltip: { container: this.regions.root }
                // }),
                form: new VContactForm({
                    profile: opt.profile
                }),
                tutorial: new VTutorialContent({
                    profile: opt.profile
                }),
            };
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext({
                appVersion: 'v' + env.APP_VERSION
            })));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.form, zone.$form)
                .assign(view.tutorial, zone.$tutorial);

            return this;
        },

        /////////////
        // actions //
        /////////////
        onActionClick: function(e) {
            e.preventDefault();
        },

        ////////////
        // events //
        ////////////

    });

    return VContactContent;

});

